import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Che de Bruin
 * id B506843C-4832-4F30-8266-9B02632AB582
 * name table-settings
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/table-settings.svg
 * tags
 * - Settings 
 */
export const TableSettingsIcon = createSvgIcon(<><path d="M7,22H9V24H7V22M11,22H13V24H11V22M15,22H17V24H15V22M5,4H19A2,2 0 0,1 21,6V18A2,2 0 0,1 19,20H5A2,2 0 0,1 3,18V6A2,2 0 0,1 5,4M5,8V12H11V8H5M13,8V12H19V8H13M5,14V18H11V14H5M13,14V18H19V14H13Z" /></>, 'TableSettingsIcon');
export default TableSettingsIcon